import {createAction} from 'redux-act';
import httpClient from '../../../services/http';

export const requestAudienceOverview = createAction();
export const responseAudienceOverview = createAction();




export function getAujdienceOverview(params){
  return (dispatch) => {
      dispatch(requestAudienceOverview([]));
      httpClient.call('ANALYTICS', '/get_audience_overview', params, {method: 'GET', headers: {}}).then(function(response){
          dispatch(responseAudienceOverview(response));
      }, function(error){
          console.log('error', error);
          dispatch(responseAudienceOverview(error));
      });
  }
}
